import {
  Button,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  Box,
  CircularProgress,
} from "@mui/material";
import { Dialog, DialogContentText } from "@mui/material";
import React, { useState } from "react";
import { apiUrl } from "../../constants";
import axios from "axios";
import { addComplementaryCoins } from "../../actions/exployee";
import { useDispatch } from "react-redux";

const ComplimentaryDialog = ({ phoneNumber, open, onClose }) => {
  const dispatch = useDispatch();
  const [complementaryCoins, setComplementaryCoins] = useState();
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const descriptionOptions = [
    { value: "DISPUTE", label: "DISPUTE" },
    { value: "PACKAGE", label: "PACKAGE" },
  ];

  const handleAddComplementaryhis = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("Login or SignUp First");
    }
    const employeeUser = await axios.get(`${apiUrl}/user/`, {
      headers: {
        token: token,
        "Content-Type": "application/json",
      },
    });

    const redeemByEmp = employeeUser.data.user.emp_id;
    const redeemByEmpPhone = employeeUser.data.user.phone_no;
    const resCusHistoryAdd = await axios.put(
      `${apiUrl}/user/addhistory`,
      {
        phone_no: phoneNumber.length !== 4 ? "+91-" + phoneNumber : phoneNumber,
        redeemBy: redeemByEmp,
        redeemOff:
          phoneNumber.length !== 4 ? "+91-" + phoneNumber : phoneNumber,
        coins: complementaryCoins,
        activity: "Complementary Coins",
      },
      {
        headers: {
          token: token,
          "Content-Type": "application/json",
        },
      }
    );
  };

  const handleAddComplementaryCoins = async (coins) => {
    setLoading(true);

    try {
      const resp = await dispatch(
        addComplementaryCoins({
          phone_no: "+91-" + phoneNumber,
          coins,
          description,
        })
      ).unwrap();

      await handleAddComplementaryhis();
      setComplementaryCoins(0);
      setDescription("");
      setSuccess(true);
    } catch (error) {
      console.error("Error adding complementary coins:", error);
      setSuccess(false);
      setError(true);
    }

    setLoading(false);
  };

  const handleClose = () => {
    setComplementaryCoins(0);
    setDescription("");
    setSuccess(false);
    setError(false);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: "20px",
          background: "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
          boxShadow: "0 25px 50px rgba(0, 0, 0, 0.25)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.2)",
          overflow: "hidden",
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)",
            borderRadius: "inherit",
            zIndex: -1,
          },
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          backdropFilter: "blur(8px)",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: "24px",
          fontWeight: "700",
          color: "#2d3748",
          textAlign: "center",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          backgroundClip: "text",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          padding: "30px 30px 15px 30px",
          position: "relative",
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: "60px",
            height: "3px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            borderRadius: "2px",
          },
        }}
      >
        Add Complementary Coins
      </DialogTitle>
      <DialogContent sx={{ padding: "30px 40px 40px 40px" }}>
        <Grid display={"flex"} flexDirection={"column"} gap={"25px"}>
          <FormControl>
            <Box sx={{ mb: 1 }}>
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#4a5568",
                  margin: "0 0 8px 0",
                }}
              >
                Fill Values
              </p>
            </Box>
            <TextField
              type="number"
              value={complementaryCoins}
              onChange={(e) => {
                const val = parseInt(e.target.value || "0");
                if (val < 0) return;
                setComplementaryCoins(val);
              }}
              placeholder="Enter coins amount"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  background: "rgba(255, 255, 255, 0.8)",
                  backdropFilter: "blur(10px)",
                  transition: "all 0.3s ease",
                  "& fieldset": {
                    borderColor: "rgba(102, 126, 234, 0.3)",
                    borderWidth: "2px",
                  },
                  "&:hover fieldset": {
                    borderColor: "rgba(102, 126, 234, 0.6)",
                    boxShadow: "0 4px 15px rgba(102, 126, 234, 0.1)",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#667eea",
                    boxShadow: "0 8px 25px rgba(102, 126, 234, 0.2)",
                  },
                },
                "& .MuiInputBase-input": {
                  color: "#2d3748",
                  fontWeight: "600",
                  fontSize: "16px",
                  padding: "14px 16px",
                },
              }}
            />
          </FormControl>

          {/* Enhanced Description Dropdown */}
          <FormControl
            fullWidth
            sx={{
              "& .MuiInputLabel-root": {
                color: "#4a5568",
                fontWeight: "600",
                "&.Mui-focused": {
                  color: "#667eea",
                },
              },
            }}
          >
            <InputLabel>Description</InputLabel>
            <Select
              value={description}
              label="Description"
              onChange={(e) => setDescription(e.target.value)}
              sx={{
                borderRadius: "12px",
                background: "rgba(255, 255, 255, 0.8)",
                backdropFilter: "blur(10px)",
                transition: "all 0.3s ease",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(102, 126, 234, 0.3)",
                  borderWidth: "2px",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(102, 126, 234, 0.6)",
                  boxShadow: "0 4px 15px rgba(102, 126, 234, 0.1)",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#667eea",
                  boxShadow: "0 8px 25px rgba(102, 126, 234, 0.2)",
                },
                "& .MuiSelect-select": {
                  color: "#2d3748",
                  fontWeight: "600",
                  padding: "14px 16px",
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    borderRadius: "12px",
                    background:
                      "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
                    boxShadow: "0 15px 35px rgba(0, 0, 0, 0.15)",
                    backdropFilter: "blur(10px)",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    "& .MuiMenuItem-root": {
                      color: "#4a5568",
                      fontWeight: "500",
                      transition: "all 0.2s ease",
                      "&:hover": {
                        background:
                          "linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)",
                        color: "#2d3748",
                      },
                      "&.Mui-selected": {
                        background:
                          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        color: "white",
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%)",
                        },
                      },
                    },
                  },
                },
              }}
            >
              <MenuItem value="">
                <em style={{ color: "#a0aec0", fontStyle: "italic" }}>
                  Select Description
                </em>
              </MenuItem>
              {descriptionOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            onClick={() => handleAddComplementaryCoins(complementaryCoins)}
            disabled={loading || !description || complementaryCoins <= 0}
            sx={{
              borderRadius: "12px",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              fontWeight: "700",
              fontSize: "14px",
              padding: "14px 24px",
              maxHeight: "50px",
              marginBottom: "4px",
              boxShadow: "0 8px 25px rgba(102, 126, 234, 0.3)",
              transition: "all 0.3s ease",
              textTransform: "none",
              "&:hover": {
                background: "linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%)",
                transform: "translateY(-2px)",
                boxShadow: "0 12px 35px rgba(102, 126, 234, 0.4)",
              },
              "&:active": {
                transform: "translateY(0px)",
              },
              "&:disabled": {
                background: "linear-gradient(135deg, #a0aec0 0%, #718096 100%)",
                color: "rgba(255, 255, 255, 0.6)",
                transform: "none",
                boxShadow: "0 4px 15px rgba(160, 174, 192, 0.2)",
              },
              border: "none",
              outline: "none",
              position: "relative",
              overflow: "hidden",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: "-100%",
                width: "100%",
                height: "100%",
                background:
                  "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)",
                transition: "left 0.5s ease",
              },
              "&:hover::before": {
                left: "100%",
              },
            }}
          >
            {loading ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <CircularProgress size={18} sx={{ color: "white" }} />
                Processing...
              </Box>
            ) : (
              "Add Complementary Coins"
            )}
          </Button>

          {success && (
            <Box
              sx={{
                padding: "12px 16px",
                background: "linear-gradient(135deg, #48bb78 0%, #38a169 100%)",
                color: "white",
                borderRadius: "10px",
                textAlign: "center",
                fontWeight: "600",
                fontSize: "14px",
                boxShadow: "0 8px 20px rgba(72, 187, 120, 0.3)",
                animation: "fadeInScale 0.3s ease-out",
                "@keyframes fadeInScale": {
                  "0%": {
                    opacity: 0,
                    transform: "scale(0.9)",
                  },
                  "100%": {
                    opacity: 1,
                    transform: "scale(1)",
                  },
                },
              }}
            >
              Successfully added coins
            </Box>
          )}

          {error && (
            <Box
              sx={{
                padding: "12px 16px",
                background: "linear-gradient(135deg, #e53e3e 0%, #c53030 100%)",
                color: "white",
                borderRadius: "10px",
                textAlign: "center",
                fontWeight: "600",
                fontSize: "14px",
                boxShadow: "0 8px 20px rgba(229, 62, 62, 0.3)",
                animation: "fadeInScale 0.3s ease-out",
                "@keyframes fadeInScale": {
                  "0%": {
                    opacity: 0,
                    transform: "scale(0.9)",
                  },
                  "100%": {
                    opacity: 1,
                    transform: "scale(1)",
                  },
                },
              }}
            >
              Failed to add coins
            </Box>
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ComplimentaryDialog;
